module.exports = __webpack_public_path__ + "img/shipinheyan.05cbdb13.png";